import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { modeActions } from "../store/modeSlice";
import { useDispatch } from "react-redux";
import appConst from "../Utilities/appConst.json";
import { loginActions } from "../store/loginSlice";
import { normalizeLanguageCode } from "../Utilities/languageDirection";

const QueryParam = () => {
  const { pathname, search } = useLocation();
  const dispatch = useDispatch();
  const lastTokenizedSearchRef = useRef(null);

  useEffect(() => {
    const query = new URLSearchParams(search);
    const ordertoken = query.get(appConst.ORDERTOKEN);
    const hasTokenizedFlow = Boolean(query.get(appConst.TOKEN) || ordertoken);
    const tokenizedSearchKey = hasTokenizedFlow ? search : null;
    const shouldResetTokenizedFlow =
      tokenizedSearchKey != null &&
      lastTokenizedSearchRef.current !== tokenizedSearchKey;

    if (shouldResetTokenizedFlow) {
      sessionStorage.clear();
      lastTokenizedSearchRef.current = tokenizedSearchKey;
    } else if (!hasTokenizedFlow) {
      lastTokenizedSearchRef.current = null;
    }

    const persistedValue = (key) =>
      shouldResetTokenizedFlow ? "" : sessionStorage.getItem(key);
    const token = query.get(appConst.TOKEN) || persistedValue(appConst.TOKEN);
    const product =
      query.get(appConst.PRODUCT) || persistedValue(appConst.PRODUCT);

    const language =
      normalizeLanguageCode(query.get(appConst.LANGUAGE)) ||
      normalizeLanguageCode(persistedValue(appConst.LANGUAGE)) ||
      "";

    let platform =
      query.get(appConst.PLATFORM) || persistedValue(appConst.PLATFORM);
    const device = query.get(appConst.DEVICE) || persistedValue(appConst.DEVICE);
    const sourceDevice =
      query.get(appConst.DEVICE_TYPE) ||
      persistedValue(appConst.SOURCE_DEVICE) ||
      appConst.DEVICE_WEB;
    const currentPlatform =
      query.get(appConst.PLATFORM) || persistedValue(appConst.PLATFORM);
    const isApp = currentPlatform == appConst.PLATFORM_APP;
    const isTopLevel = window.self === window.top;
    const showHeaderParam =
      query.get(appConst.SHOW_HEADER) ?? persistedValue(appConst.SHOW_HEADER);
    const showHeader = isApp
      ? false
      : isTopLevel
        ? "true"
        : showHeaderParam;

    if (!isApp) {
      switch (product) {
        case appConst.BOOKS:
          platform = appConst.BOOKS;
          break;
        case appConst.CALENDARS:
          platform = appConst.CALENDARS_V3;
          break;
        default:
          break;
      }
    } else {
      platform = appConst.PLATFORM_VAR_3;
    }

    dispatch(modeActions.setLaguage(language));
    dispatch(modeActions.setProduct(product));
    dispatch(modeActions.setPlatform(platform));
    dispatch(modeActions.setDevice(device));
    dispatch(modeActions.setSourceDevice(sourceDevice));
    dispatch(modeActions.setShowHeader(showHeader));
    dispatch(modeActions.setQuary(query.toString()));
    dispatch(loginActions.setToken(token));

    if (ordertoken) {
      sessionStorage.setItem(appConst.ORDERTOKEN, ordertoken);
      window.location = appConst.NINTH_PAGE;
    }
  }, [dispatch, search]);

  useEffect(() => {
    dispatch(modeActions.setPath(pathname));
  }, [dispatch, pathname]);

  return <div></div>;
};

export default QueryParam;
